import React from 'react'
import moment from 'moment'

import DateField from 'pmt-ui/DateField'

const getComponents = () => [
  {
    name: 'DateField INLINE',
    definition: (
      <pre>
        {`
        <DateField
          mode={DateField.Mode.INLINE}
          label="Date de naissance"
          value={formData.birthdate}
          onChange={birthdate => onChange({ ...formData, birthdate })}
          validation={formErrors.birthdate}
          options={{
            defaultDate: moment().subtract(30, 'year').startOf('day'),
            minDate: moment().subtract(100, 'year').startOf('day'),
            maxDate: moment().subtract(12, 'year').startOf('day'),
          }}
        />
        `}
      </pre>
    ),
    render: (
      <DateField
        mode={DateField.Mode.INLINE}
        label="Date de naissance"
        value={moment()}
        onChange={() => {}}
        options={{
          defaultDate: moment()
            .subtract(30, 'year')
            .startOf('day'),
          minDate: moment()
            .subtract(100, 'year')
            .startOf('day'),
          maxDate: moment()
            .subtract(12, 'year')
            .startOf('day'),
        }}
      />
    ),
  },
  {
    name: 'DateField CALENDAR',
    definition: (
      <pre>
        {`
        <DateField
          mode={DateField.Mode.CALENDAR}
          value={formData.birthdate}
          onChange={birthdate => onChange({ ...formData, birthdate })}
          validation={formErrors.birthdate}
          options={{
            defaultDate: moment().subtract(30, 'year').startOf('day'),
            minDate: moment().subtract(100, 'year').startOf('day'),
            maxDate: moment().subtract(12, 'year').startOf('day'),
          }}
        />
        `}
      </pre>
    ),
    render: (
      <DateField
        label="Calendar"
        mode={DateField.Mode.CALENDAR}
        value={moment()}
        onChange={() => {}}
        options={{
          defaultDate: moment()
            .subtract(30, 'year')
            .startOf('day'),
          minDate: moment()
            .subtract(100, 'year')
            .startOf('day'),
          maxDate: moment()
            .subtract(12, 'year')
            .startOf('day'),
        }}
      />
    ),
  },
  {
    name: 'Calendar CALENDAR inline',
    definition: (
      <pre>
        {`
          <DateField
            mode={DateField.Mode.CALENDAR}
            label="Date de naissance"
            value={formData.dateRangeTest}
            onChange={dateRangeTest => onChange({ ...formData, dateRangeTest })}
            options={{
              inline: true,
              mode: 'range',
            }}
        `}
      </pre>
    ),
    render: (
      <DateField
        mode={DateField.Mode.CALENDAR}
        label="Date de naissance"
        value={moment()}
        onChange={() => {}}
        options={{
          inline: true,
          mode: 'range',
        }}
      />
    ),
  },
]

export default {
  title: 'Calendar',
  getComponents: getComponents,
}
